import { render } from "./BuySell.vue?vue&type=template&id=894982c6&scoped=true"
import script from "./BuySell.vue?vue&type=script&lang=js"
export * from "./BuySell.vue?vue&type=script&lang=js"

import "./BuySell.vue?vue&type=style&index=0&id=894982c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894982c6"]])

export default __exports__